/**
 * 価格情報
 */
export class PriceInfo {
    /** 単価 */
    unitPrice = 0
    /** 数量 */
    quantity = 1
    /** 消費税率 */
    taxRate = 0.0

    /**
     * コンストラクタ
     * @param init 
     */
    constructor(init?: Partial<PriceInfo>) {
        Object.assign(this, init)
    }
}
